<table class="weaveRepeater">
  <thead>
    @for (field of fields; track field) {
      <th [ngClass]="{'hiddenColumn': field.type === 'hidden' }">
        @if (field.type !== 'hidden') {
          {{ field.label }} @if (field.required) {
          *
        }
      }
    </th>
  }
  <th class="editTh"></th>
</thead>
<tbody>
  @for (value of values; track value; let i = $index) {
    <tr>
      @for (field of fields; track field) {
        <td [ngClass]="{'hiddenColumn': field.type === 'hidden' }">
          @if (field.type === 'input') {
            <app-weave-input
              [data]="value[field.propertyName]"
              [placeholder]="field.placeholder || ''"
              [required]="field.required"
              (focusOut)="emitValues(value, field.propertyName, $event)"
              [showError]="showErrors"
            ></app-weave-input>
          }
          @if (field.type === 'email') {
            <app-weave-email
              [data]="value[field.propertyName]"
              [placeholder]="field.placeholder || ''"
              [required]="field.required"
              (focusOut)="emitValues(value, field.propertyName, $event)"
              [showError]="showErrors"
            ></app-weave-email>
          }
          @if (field.type=='percentage') {
            <app-percentage-input
              [data]="value[field.propertyName]"
              [required]="field.required"
              (focusOut)="emitValues(value, field.propertyName, $event)"
              [showError]="showErrors"
              >
            </app-percentage-input>
          }
          @if (field.type=='currency') {
            <app-weave-currency
              [data]="value[field.propertyName]"
              [required]="field.required"
              [showError]="showErrors"
              (focusOut)="emitValues(value, field.propertyName, $event)"
            ></app-weave-currency>
          }
          @if (field.type === 'select' || field.type === 'prefixSelect' || field.type === 'degreeSelect') {
            <app-weave-select
              [showLabel]="false"
              [data]="value[field.propertyName]"
              [options]="field.selectValues"
              [required]="field.required"
              (focusOut)="emitValues(value, field.propertyName, $event)"
              [showError]="showErrors"
            ></app-weave-select>
          }
          @if (field.type === 'checkbox') {
            <app-weave-checkbox-group
              [checkboxList]="$any(field.selectValues)"
              [required]="field.required"
              [initialData]="value[field.propertyName]"
              (changed)="emitValues(value, field.propertyName, $event)"
              [showError]="showErrors"
            ></app-weave-checkbox-group>
          }
          @if (field.type === 'hidden') {
            <input type="hidden" [value]="value[field.propertyName]">
          }
        </td>
      }
      <td class="editTd">
        <button mat-button [matMenuTriggerFor]="functionsMenu">
          <i class="material-icons">more_vert</i>
        </button>
        <mat-menu #functionsMenu="matMenu" xPosition="before" class="functionsMenu">
          <button mat-menu-item (click)="removeRow(i)" class="removeRow">
            <i class="material-icons">delete</i> Remove Row
          </button>
        </mat-menu>
      </td>
    </tr>
  }
</tbody>
</table>

<button class="plusButton plusButton_dark" (click)="addRow()">Add Row</button>
